import { ScrollbarInst } from 'naive-ui';
import { inject, Ref } from 'vue';

export const useScroll = () => {
  const scrollRef = inject<Ref<ScrollbarInst>>('scrollRef');

  const scrollToTop = () => {
    scrollRef?.value?.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  };

  return {
    scrollToTop,
  };
};
